module.exports = __webpack_public_path__ + "static/media/pic_portrait.0dc085b9.jpg";